import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { oktaAuthConfig } from '../../config';

const enhancedOktaConfig: OktaAuthOptions = {
  ...oktaAuthConfig,
  tokenManager: {
    ...oktaAuthConfig.tokenManager,
    // autoRenew makes the SDK's AutoRenewService own token expiry. It renews
    // through tokenManager.renew(), which dedupes concurrent attempts - do not
    // add a competing 'expired' handler in app code.
    autoRenew: true,
    // Deliberately not setting expireEarlySeconds: okta-auth-js overwrites it
    // with its 30s default anywhere but localhost (TokenManager constructor),
    // so a custom value here reads as a real setting while doing nothing.
    // storage is inherited from oktaAuthConfig which includes createSecureStorage()
  },
  cookies: {
    secure: true,
    sameSite: 'lax' as const,
  },
};

export const oktaAuth = new OktaAuth(enhancedOktaConfig);
